import { linkListStyles } from "@insite/content-library/Widgets/Basic/LinkList";
import { StyledButton } from "@insite/mobius/Clickable";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import ADIColors from "@NA/Utils/ADIColors";
import { css } from "styled-components";

linkListStyles.linkListWrapper = {
    css: css`
        padding: 10px 0;
    `,
},

    linkListStyles.linkWrapper = {
        css: css`
     padding: 0px 0px 0 0;&:last-child {
            padding: 0 0 10px 0;
        }
        >${StyledButton}{
            &:focus{
                outline: none;
                text-decoration: underline;
            }
            &:hover{
                color: ${ADIColors.gray6}!important;
                >${TypographyStyle}{
                    color: ${ADIColors.gray6};
                }
            }
            >${TypographyStyle}{
                font-size: 14px;
                line-height: 24px;
                margin-top: 12px;
                color: ${ADIColors.gray6};
                &:hover{
                    color: ${ADIColors.gray6};
                    text-decoration: underline;
                }
                @media only screen and (max-width: 1080px) {
                       font-size: 14px;
                       font-weight: 600;
                       margin-top:10px;
                       line-height:normal;
                }    
            }
        }
    `,
    }

linkListStyles.titleWrapper = {
    css: css`
        font-weight: bold;
        >${StyledButton}{
            cursor: default;
            pointer-events: none;
            >${TypographyStyle}{
                font-size: 14px;
                color: ${ADIColors.gray6};
            }
        }
    `,
}